'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../builder');

let ElementClass = require('./../elementClass');

FormBuilder.register('hidden', function(config) {
    let self = {};

    self = new ElementClass(config);

    self.render = function() {
        let $element = jQuery('<input/>');

        $element.attr('type', 'hidden');
        $element.attr('name', self.name);

        if (self.value !== undefined && self.value !== null) {
            $element.val(self.value);
        }

        return $element;
    };

    self.getData = function() {
        return self.$.find('input:first').val();
    };

    return self;
});
